module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/5.3-template-config.448b17d8.png";